export const sxStyle = {
  root: {
    backgroundColor: '#F3F3F3',
    flexWrap: 'nowrap',
    flexDirection: {
      xs: 'column',
      lg: 'row',
    },
    width: '100%',
    px: { xs: '16px', md: '32px', lg: '116px' },
  },
  rootLoating: {
    backgroundColor: '#F6F6F6',
    px: { xs: '16px', md: '32px', lg: '116px' },
  },
  rootNoResultsText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: {
      xs: '30px',
      sm: '0',
    },
    minHeight: {
      xs: 'auto',
      sm: '350px',
    },
  },
  noResultsText: {
    color: '#000000',
    fontWeight: 600,
    fontSize: '24px',
    padding: '20px',
  },
  noCity: {
    color: '#000000',
    fontSize: '20px',
    fontWeight: 400,
    textAlign: 'center',
  },
  skeletonText: {
    padding: '20px 0px',
    height: '18px',
    width: '100%',
  },
  skeletonFilter: {
    width: {
      xs: '100%',
      sm: '400px',
    },
    maxWidth: '420px',
    height: '300px',
    marginTop: '10px',
    borderRadius: '5px',
    marginRight: '30px',
  },
  noFiltersResults: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '80vh',
    width: '100%',
    fontFamily: 'Open Sans,sans-serif',
    flexDirection: 'column',
  },
};
